/*
* Created on Jan 25, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import {useState} from 'react';

const useInputHandler = ({initial={}, validator}) => {
    const [input, setInput] = useState(initial);

    const handleInputChange = (e) => {
        let value =  e.currentTarget.value;
        if (e.currentTarget.type === 'checkbox') {
            value = e.currentTarget.checked;
        }
        return setInput({
            ...input,
            [e.currentTarget.name]: {value, error: null}
        })
    }
    return [input, setInput, handleInputChange];
};

export default useInputHandler;